export const GET_CLASS_CHINESE_FRM_SUCCESS = 'GET_CLASS_CHINESE_FRM_SUCCESS';
export const GET_CLASS_CHINESE_FRM_CONFIRM_SUCCESS = 'GET_CLASS_CHINESE_FRM_CONFIRM_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
